import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  children: React.ReactNode;
  href?: string;
}
export function Button({
  variant = 'primary',
  children,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-3 text-base font-medium rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-[#1e3a8a] text-white hover:bg-[#1e40af] focus:ring-blue-900',
    secondary: 'bg-white text-[#1e3a8a] border border-[#1e3a8a] hover:bg-blue-50 focus:ring-blue-900',
    outline: 'bg-transparent text-white border border-white hover:bg-white/10 focus:ring-white'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${className}`;
  // Animation props for hover
  const motionProps = {
    whileHover: {
      scale: 1.02
    },
    whileTap: {
      scale: 0.98
    }
  };
  if (href) {
    return <motion.a href={href} className={combinedClassName} {...motionProps} target={href.startsWith('http') ? '_blank' : undefined} rel={href.startsWith('http') ? 'noopener noreferrer' : undefined} data-id="element-176">
        {children}
      </motion.a>;
  }
  return <motion.button className={combinedClassName} {...props} {...motionProps} data-id="element-177">
      {children}
    </motion.button>;
}